module.exports = __webpack_public_path__ + "img/pitchup.com-vector-logo.5cdeac8.svg";